module.exports = __webpack_public_path__ + "static/media/webapp_dev.7ab0b0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/webapp_dev.jpg
// module id = 378
// module chunks = 0